import exportExcel from './ExportExcel.vue'
let exportEx = {}
exportEx.install = function(Vue) {
  Vue.component(exportExcel.name, exportExcel)
}
export default exportEx